export const assessment_update = {
  pre_update_changes_filename:
    "Cambios_Pre_Actualizacion_{{preVersion}}_a_{{postVersion}}_{{assessment}}_{{tenant}}_{{dateTime}}.xlsx",
  post_update_changes_filename:
    "Cambios_Post_Actualizacion_{{preVersion}}_a_{{postVersion}}_{{assessment}}_{{tenant}}_{{dateTime}}.xlsx",
  "Are_you_sure_you_want_to_migrate?": "¿Estás seguro de que quieres migrar?",
  Assessment_Update_Dry_Run: "Actualización de la evaluación",
  Assessment_Update_List: "Lista de actualización de evaluaciones",
  Back_to_list: "Volver a la lista",
  Completed: "Terminado",
  Created: "Creado",
  Current_protocol_set_mapping_version: "Versión actual de mapeo de protocolo",
  Deleted: "Eliminado",
  Download_JSON: "Descargar JSON",
  Dry_Run: "Ejecución de prueba",
  Has_data: "Tiene datos",
  Inactive: "Inactivo",
  Is_renamed: "Se renombra",
  Migrate: "Migrar",
  Migrated: "Migrado",
  No_changes: "Sin cambios",
  No_changes_needed: "No se necesitan cambios",
  Protocol_Question_Name: "Nombre de la pregunta de protocolo",
  Protocol_Question_New_Name: "Nuevo nombre de la pregunta de protocolo",
  Protocol_Question_Old_Name: "Nombre antiguo de la pregunta de protocolo",
  protocol_set_changes: "Cambios del conjunto de protocolos",
  Site_name: "Nombre del sitio",
  Stakeholder_Report: "Informe de partes interesadas",
  Technical_Report: "Informe técnico",
  There_are_no_assessments_for_this_tenant: "No hay evaluaciones para este inquilino",
  To_create: "Para crear",
  To_delete: "Para eliminar",
  To_migrate: "Para migrar",
  Update: "Actualizar",
  Upgrade_to_latest: "Actualizar a la última versión",
  assessment_is_already_updated: "La evaluación ya se ha actualizado",
  show_history: "Mostrar historial",
} as const;
